import React, { Component } from 'react';
import Map from './Map';

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lettemlatti: "",
			lettemlandittti: ""
		}
	}

	render() {
		let { lettemlatti, lettemlandittti } = this.state;

		return (
			<>
				< div style={{ margin: '100px' }}>
					<Map
						google={this.props.google}
						center={{ lat: 13.018916, lng: 80.207064 }}
						height='300px'
						zoom={22}
					/>
				</div >

			</>
		);
	}
}
export default Home;